import { render, staticRenderFns } from "./PComponentLoader.vue?vue&type=template&id=97b53e74&"
import script from "./PComponentLoader.vue?vue&type=script&lang=js&"
export * from "./PComponentLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports